/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Injectable} from '@angular/core';
import {OverlayContainer} from './overlay-container';
/**
 * The FullscreenOverlayContainer is the alternative to OverlayContainer
 * that supports correct displaying of overlay elements in Fullscreen mode
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/requestFullScreen
 * It should be provided in the root component that way:
 * providers: [
 *   {provide: OverlayContainer, useClass: FullscreenOverlayContainer}
 * ],
 */
export class FullscreenOverlayContainer extends OverlayContainer {
/**
 * @return {?}
 */
protected _createContainer(): void {
    super._createContainer();
    this._adjustParentForFullscreenChange();
    this._addFullscreenChangeListener(() => this._adjustParentForFullscreenChange());
  }
/**
 * @return {?}
 */
private _adjustParentForFullscreenChange(): void {
    if (!this._containerElement) {
      return;
    }
    let /** @type {?} */ fullscreenElement = this.getFullscreenElement();
    let /** @type {?} */ parent = fullscreenElement || document.body;
    parent.appendChild(this._containerElement);
  }
/**
 * @param {?} fn
 * @return {?}
 */
private _addFullscreenChangeListener(fn: () => void) {
    if (document.fullscreenEnabled) {
      document.addEventListener('fullscreenchange', fn);
    } else if (document.webkitFullscreenEnabled) {
      document.addEventListener('webkitfullscreenchange', fn);
    } else if (( /** @type {?} */((document as any))).mozFullScreenEnabled) {
      document.addEventListener('mozfullscreenchange', fn);
    } else if (( /** @type {?} */((document as any))).msFullscreenEnabled) {
      document.addEventListener('MSFullscreenChange', fn);
    }
  }
/**
 * When the page is put into fullscreen mode, a specific element is specified.
 * Only that element and its children are visible when in fullscreen mode.
 * @return {?}
 */
getFullscreenElement(): Element {
    return document.fullscreenElement ||
        document.webkitFullscreenElement ||
        ( /** @type {?} */((document as any))).mozFullScreenElement ||
        ( /** @type {?} */((document as any))).msFullscreenElement ||
        null;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function FullscreenOverlayContainer_tsickle_Closure_declarations() {
/** @type {?} */
FullscreenOverlayContainer.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FullscreenOverlayContainer.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
